export const enum CustomErrorCode {
    TOO_MANY_ENDPOINT_CALLS = `TOO_MANY_ENDPOINT_CALLS`
}